import API from "../api/axios";

// ─── Get Single Lead ───
export const getLead = (id) => {
   return API.get(`/leads/${id}`);
};

// ─── Get Lead Followups ───
export const getLeadFollowups = (id) => {
   return API.get(`/followups/${id}`);
};

// ─── Add Lead Followup ───
export const addLeadFollowup = (data) => {
   return API.post("/followups", data);
};

// ─── Get Lead Activities ───
export const getLeadActivities = (id) => {
   return API.get(`/leads/${id}/activities`);
};